import { TToolbarItem } from 'reactApp/ui/Toolbar/Toolbar.types';

export const shouldCollapse = (data: TToolbarItem, priority: number, responsiveMode: boolean): boolean => {
    if (data.collapse !== undefined) {
        return data.collapse;
    }

    return (!!data?.priority && data?.priority <= priority) || responsiveMode;
};
